// Types
import type { TTableHeaders } from '~/misc/v-table-sortable/types';
import { EManagerExternalOfficesSorting } from '~/modules/manager/types';

const TABLE_HEADERS: TTableHeaders = [
  { label: 'Office', key: EManagerExternalOfficesSorting.NAME, sortable: true },
  { label: 'Address', key: EManagerExternalOfficesSorting.ADDRESS, sortable: true },
  { label: 'Active', key: EManagerExternalOfficesSorting.ACTIVE, sortable: true },
  { label: 'Enabled', key: EManagerExternalOfficesSorting.ENABLED, sortable: true },
  { label: 'Opportunities', key: EManagerExternalOfficesSorting.OPPORTUNITIES, sortable: true },
  { label: 'Contacts', key: EManagerExternalOfficesSorting.CONTACTS, sortable: true },
  { label: 'Users', key: EManagerExternalOfficesSorting.USERS, sortable: true },
  { label: 'Sync status', key: 'sync_status', sortable: false },
  { label: '', key: 'actions', sortable: false },
];

export { TABLE_HEADERS };
